<template>
  <div class="login_warp">
    <!-- 左下角那一坨 bg2 -->
    <div class="bg2" :class="{'bg2_opacity': animationBg2}"></div>
    <div class="login-box" id="login">
      <div class="loginwarp" :class="[{'reg-warp': isRegisterShow},transitionStu ? 'login-active' : 'login-disActive']" v-loading="loadingLogin" :element-loading-text="loadingText">
        <!-- 二维码切换 -->
        <img
          v-show="!isRegisterShow"
          :src="isQRlogin?'/static/icon/userInfo_login.png':'/static/icon/QR_login.png'"
          alt
          class="qrlogin"
          @click="changeFunction"
        />

        <!-- 提示点击 -->
        <div v-show="!isRegisterShow" class="hitClick">
          <span class="texts">
            {{isQRlogin?"账号登录":"微信扫码登录"}}
            <span></span>
          </span>
          <img src="/static/icon/finger.png" alt />
        </div>
        <!-- logo -->
        <div v-show="!isRegisterShow" class="loginIcon">
          <img src="/static/logo.png" alt />
        </div>
        <!-- 二维码 -->
        <div class="superQr" v-show="isQRlogin">
          <div style="position: relative;">
            <img :src="QR_pic" alt />
            <img src="/static/icon/QR_logo.png" alt class="QR_logo" />
            <div class="models" @click="refreshQr" v-if="isRefreshQrShow">二维码已过期，点击刷新</div>
          </div>
          <div class="loginHit">
            微信扫一扫
            <br />登录更快更安全
          </div>
        </div>
        <div v-show="isRegisterShow" class="reg-text">注册</div>
        <!-- 账号密码 -->
        <el-form
          label-width="70px"
          label-position="top"
          :model="loginForm"
          :rules="loginRuler"
          ref="loginref"
          v-show="method&&!isQRlogin&&!isRegisterShow"
          @keyup.enter.native="loginEnter('loginref')"
        >
          <el-form-item label="手机号:" prop="loginName" class="inputItem">
            <el-input v-model.trim="loginForm.loginName" placeholder="请输入您手机号码!" clearable></el-input>
          </el-form-item>
          <el-form-item label="验证码:" prop="securityCode" class="inputItem">
            <el-input v-model="loginForm.securityCode" placeholder="请输入验证码!" clearable>
              <template slot="append">
                <el-button :disabled="disable" @click="postValide(loginForm.loginName)">{{msg}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button style="width:100%;background-color: #20BD90;color: #fff;" @click="loginEnter('loginref')">登录</el-button>
            <el-button style="width:100%;margin:.20rem 0 0" @click="disShow = true;">申请体验</el-button>
            <div class="change">
              <el-link class="change__btn change__btn--method" :underline="false" @click="handleChangeLogin">账号密码登录</el-link>
              <el-link class="change__btn change__btn--login" :underline="false" @click="goRegisterLogin">
                <span class="change__btn--tip">暂无账号，</span>
                去注册
                <i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
          </el-form-item>
        </el-form>

        <el-form
          label-width="70px"
          label-position="top"
          :model="loginForm1"
          :rules="loginRuler1"
          ref="loginref1"
          v-show="!method&&!isQRlogin&&!isRegisterShow"
          @keyup.enter.native="loginEnter('loginref1')"
        >
          <el-form-item label="账户:" prop="loginName" class="inputItem">
            <el-input v-model.trim="loginForm1.loginName" placeholder="请输入您手机号码!" clearable @blur="checkUserAlign"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password" class="inputItem">
            <el-input type="password" v-model="loginForm1.password" placeholder="请输入密码!" clearable></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button style="width:100%;background-color: #20BD90;color: #fff;" @click="loginEnter('loginref1')">登录</el-button>
            <el-button style="width:100%;margin:.20rem 0 0" @click="disShow = true;">申请体验</el-button>
            <div class="change">
              <el-link class="change__btn change__btn--method" :underline="false" @click="handleChangeLogin">验证码登录</el-link>
              <el-link class="change__btn change__btn--login" :underline="false" @click="goRegisterLogin">
                <span class="change__btn--tip">暂无账号，</span>
                去注册
                <i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
          </el-form-item>
        </el-form>
        <!-- 注册表单 -->
        <el-form
          v-show="isRegisterShow"
          ref="registerForm"
          label-width="70px"
          label-position="top"
          :model="registerForm"
          :rules="registerFormRules"
          @keyup.enter.native="registerSend('registerForm')"
        >
          <el-form-item label="用户名:" prop="name" class="inputItem">
            <el-input v-model.trim="registerForm.name" placeholder="请输入用户名" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile" class="inputItem">
            <el-input v-model.trim="registerForm.mobile" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="Pwd" class="inputItem">
            <el-input type="password" v-model="registerForm.Pwd" placeholder="请输入密码" clearable></el-input>
          </el-form-item>
          <el-form-item label="验证码:" prop="securityCode" class="inputItem">
            <el-input v-model="registerForm.securityCode" placeholder="请输入验证码" clearable>
              <template slot="append">
                <el-button :disabled="disable" @click="postValide(registerForm.mobile, 1)">{{msg}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button
              style="width:100%;background-color: #20BD90;color: #fff;"
              :loading="registerFormLoading"
              @click="registerSend('registerForm')"
            >确定</el-button>
            <div class="change change--flex-end">
              <el-link class="change__btn change__btn--login" :underline="false" @click="goRegisterLogin">
                <span class="change__btn--tip">已有账号，</span>
                账号登录
                <i class="el-icon-arrow-right"></i>
              </el-link>
            </div>
          </el-form-item>
        </el-form>
        <!-- <div class='register'>
                <span @click='handleClickRegister'>点我注册</span>
        </div>-->
      </div>
      <!-- welcome -->
      <img class="login-welcome" src="/static/login/welcome.png" alt="">
      <!-- 灯光 -->
      <div class="light-effects" :class="[transitionStu ? 'activeEffects' : 'disEffects']">
        <img class="light-effects" src="/static/login/light.png" alt="" />
      </div>
      <!-- 门 -->
      <img class="login-door" src="/static/login/door.png" alt="">
      <!-- 飞船 -->
      <div class="login-airship" :class="{'bg2_opacity': animationBg2}">
        <img src="/static/login/airship.png" alt="">
        <div class="airship_shadow"></div>
      </div>
    </div>
    <template v-if="animationBg2">
      <!-- 星星 -->
      <!-- <div class="star" v-for="item in 100" :key="item" :style="{'top': Math.round(Math.random()*100) + '%','left':Math.round(Math.random()*100) + '%','animation-delay': `${Math.random()}s`,}"></div> -->
      <!-- 流星 -->
      <div class="meteor" v-for="(item,i) in 4" :key="i*Math.random()" 
        :style="{
          'top':Math.round(Math.random()*30) + '%',
          'left': Math.random() * leftPosition + '%',
          'animation-delay': `${item*Math.random()}s`,
        }">
      </div>
    </template>
    
    <div class="company">
      
      <div class="company-content">
        Copyright &#169; 2017 四川小蝌蚪科技有限公司. All Rights Reserved.
        <a href="https://www.beian.gov.cn" title target="_blank">蜀ICP备17040116号-2</a>
      </div>
    </div>
    <!-- 服务定制 -->
    <el-dialog
      title="服务定制"
      :visible.sync="disShow"
      width="1200px"
      class="userVips">
      <div class="vipsWarp" v-loading='disShow_loading'>
        <h2>服务定制</h2>
        <span>资讯,解决,健康体检、7*24小时安全保障、首席专家服务、财务托管等服务</span>
        <el-form label-width="100px" label-position="top" inline :model="vipForm" :rules="vipsRuler"  ref="vipsref" >
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="vipForm.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="公司:" prop="companyName">
            <el-input v-model="vipForm.companyName" placeholder="请输入您的公司名称"></el-input>
          </el-form-item>
          <el-form-item label="电话:" prop="phone">
            <el-input v-model="vipForm.phone" placeholder="请输入您的电话号码"></el-input>
          </el-form-item>
          <el-form-item label="商务邮箱:" prop="email">
            <el-input v-model="vipForm.email" placeholder="请输入您的是商务邮箱"></el-input>
          </el-form-item>
          <el-form-item label="头衔:" prop="title">
            <el-input v-model="vipForm.title" placeholder="请输入您的职位"></el-input>
          </el-form-item>
          <el-form-item label="雇员人数:" prop="employees">
            <el-input v-model="vipForm.employees " placeholder="请输入您的公司实际在职人数"></el-input>
          </el-form-item>
          <div class="checkBoxContainer">
            <el-checkbox v-model="vipForm.agree" class="checkBoxContainer_check" @change='handleCheckChange'>我同意
              <div class='agree' @click='handleClickRead("1")'>《好账先生服务条款》</div>
              <div class='agree' @click='handleClickRead("2")'>《好账先生隐私条款》</div>
              并与Mankoo分享此信息</el-checkbox>
              <span class='f14' :style='checkboxStyle'>，官方客服可能会使用它来进行有关的演示，优惠和更新的信息。</span>
          </div>
          <el-form-item label="">
            <el-button type='warning' :disabled='isButtonDisbale' class="btn-bj" @click="getVipsPrice('vipsref')">获取报价</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- CDK用户 -->
    <cdk-select 
			:dialog-visible.sync="cdkVisible" 
			:loginName="cdkSelectLoginName"
			@hzUseCdkey="hzUseCdkey"
			@view-tems="handleClickRead($event)" 
		/>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import store from "@/store"
import cdkSelect from "@/components/dialog/CDKSelect"

export default {
  components: {
    cdkSelect
  },
  data() {
    const cellphone = (rules, value, callback) => {
      let exp = /^1[0-9]{10}$/
      if (value == "") {
      } else if (!exp.test(value)) {
        callback(new Error("输入正确的手机号码!"))
      } else {
        callback()
      }
    }
    return {
      leftPosition: Math.round(Math.random()*100),
      transitionStu: false, // 登录动画的状态
      animationBg2: false, // 背景2的动画
      isRefreshQrShow: false, // 二维码过期显示
      isQRlogin: true, // 是否二维码登录
      socketPath: "http://192.168.1.254:81/socket/sockjs",
      socketPath1: "ws://192.168.1.254:81/socket",
      time_Qr: null, // 二维码轮询计时器
      QRkey: "", // 二维码key
      QR_pic: "", // 二维码图片地址
      checkboxStyle: {
        color: "#333"
      },
      // 注册表单
      registerForm: {
        mobile: "", // 注册号码
        name: "", // 用户名
        securityCode: "", // 验证码
        Pwd: "" // 密码
      },
      handlePicker: {
        // 日期限制
        disabledDate: time => {
          let startVal = new Date().getTime()
          if (startVal) {
            return time.getTime() < startVal
          }
        }
      },
      registerFormLoading: false, // 注册Loading
      isRegisterShow: false, // 注册
      disShow_loading: false, // 获取报价loading
      isButtonDisbale: false, // 防止重复点击
      title: "",
      disShow: false,
      method: false,
      msg: "发送验证码",
      disable: false,
      loadingLogin: false,
      loadingText: "拼命登录中..",
      vipForm: {
        name: "",
        companyName: "",
        phone: "",
        email: "",
        title: "",
        employees: "",
        agree: ""
      },
      vipsRuler: {
        name: [{ required: true, message: "请你填写您的名字" }],
        companyName: [{ required: true, message: "请您填写您的公司名字" }],
        phone: [{ required: true, message: "请您填写您的电话号码" }],
        email: [{ required: true, message: "请您填写您的商务邮箱" }],
        title: [{ required: true, message: "请您填写您的职位" }],
        employees: [{ required: true, validator: this.isexChangerate }]
      },
      registerFormRules: {
        // 注册验证
        mobile: [{ required: true, message: "请输入手机号" }], // 电话号码
        name: [{ required: true, message: "请输入用户名" }], // 用户名
        securityCode: [{ required: true, message: "请输入验证码" }], // 验证码
        Pwd: [{ required: true, message: "请输入密码" }] // 密码
      },
      loginForm: {
        loginName: "",
        securityCode: ""
      },
      loginForm1: {
        loginName: "",
        password: ""
      },
      loginRuler: {
        loginName: [{ required: true, message: "请输入手机号码!" }],
        securityCode: [{ required: true, message: "请输入验证码!" }]
      },
      loginRuler1: {
        loginName: [{ required: true, message: "请输入登录用户名!" }],
        password: [{ required: true, message: "请输入登录密码!" }]
      },
      // cdk选择
      cdkVisible: false,
      cdkSelectLoginName: "" // 使用cdk和获取cdk列表使用
    }
  },
  computed: {
    QR_loginStatus() {
      return this.$store.state.webSockets.RecodeLogin
    }
  },
  created() {
    this.getQR_pic()
  },
  mounted() {
    setTimeout(() => {
      this.transitionStu = true
    },600)
    setTimeout(() => {
      this.animationBg2 = true
    },800)
    setInterval(() => {
      this.leftPosition = this.randomPosition()
    },8000)
  },
  destroyed() {
    // 销毁监听
    // this.$webSocket.ws_close();
  },
  methods: {
    ...mapMutations(["ADDROUTECHILD", "IS_FIRST_LOGIN"]),
    // 随机的left和top 
    randomPosition() {
      return Math.round(Math.random()*100)
    },
    // 点击切换登录方式
    changeFunction() {
      this.isQRlogin = !this.isQRlogin
      this.isRegisterShow = false
      if (this.isQRlogin) {
        this.getQR_pic()
      }
    },
    // 刷新二维码
    refreshQr() {
      this.getQR_pic()
    },
    // 获取二维码
    getQR_pic() {
      this.$http.post("sys/account/getWxCode", {}).then(res => {
        if (res && res.data.code == 1) {
          this.isRefreshQrShow = false
          this.QRkey = res.data.data.key
          this.QR_pic = "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=" + res.data.data.ticket
          var object = {
            key: this.QRkey,
            type: "QRcode",
            time: new Date().getTime()
          }
          setTimeout(() => {
            this.isRefreshQrShow = true
          }, res.data.data.expire_seconds * 1000)
          this.$webSocket.sendMsg(object)
        }
      })
    },
    //人数验证
    isexChangerate(rule, value, callback) {
      if (!value) {
        return callback(new Error("雇员人数不能为空！"))
      }
      setTimeout(() => {
        if (!Number(value)) {
          return callback(new Error("雇员人数只能是数字！"))
        } else {
          return callback()
        }
      })
    },
    // 登录切换
    handleChangeLogin() {
      if (this.method) {
        this.$set(this.loginForm1, "loginName", this.loginForm.loginName)
      } else {
        this.$set(this.loginForm, "loginName", this.loginForm1.loginName)
      }
      this.method = !this.method
    },
    // checkbox change
    handleCheckChange(val) {
      if (val) {
        this.$set(this.checkboxStyle, "color", "#269D7B")
      } else {
        this.$set(this.checkboxStyle, "color", "#333")
      }
    },
    // 去注册或去登陆
    goRegisterLogin() {
      if (!this.isRegisterShow) {
        this.isRegisterShow = true
        // 防止自动填充
        this.$refs.registerForm.resetFields()
        return
      }
      this.isRegisterShow = false
      this.method = false
    },
    // 确认注册
    registerSend(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.registerFormLoading = true
          this.$http
            .post("sys/account/save", this.registerForm)
            .then(res => {
              this.registerFormLoading = false
              if (res && res.data.code == 1) {
                this.$message.success("注册成功！")
                this.goRegisterLogin()
                // 清除登陆框信息，并附上当前注册的号码
                this.$refs.loginref1.resetFields()
                this.loginForm1.loginName = this.registerForm.mobile
              }
            })
            .catch(() => (this.registerFormLoading = false))
        }
      })
    },
    // 使用CDKEY使用成功
    hzUseCdkey() {
      this.cdkVisible = false
      this.$message.success("使用成功，请重新登录")
    },
    loginEnter(ref) {
      const _ = this
      _.$store.commit("REQUEXTHTTP_ONE", true)
      _.$refs[ref].validate(valid => {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_.loginForm))
          if (ref == "loginref1") {
            data = JSON.parse(JSON.stringify(_.loginForm1))
          }
          _.loadingLogin = true
          _.$http
            .post("sys/login/login", data)
            .then(res => {
              _.loadingLogin = false
              if (res && res.data.code == "1") {
                const data = res.data.data
                if (data.cdkey) {
                  this.cdkVisible = true
                  this.cdkSelectLoginName = data.loginName
                  return
                }
                this.loginSuccess(res)
              } else if (res.data.code == "250") {
                _.loginForm.loginName = _.loginForm1.loginName
                _.method = true
              }
            })
            .catch(e => {
              _.loadingLogin = false
            })
        }
      })
    },

    // 登录成功！
    loginSuccess(res) {
      const _ = this

      let objects = {
        userId: res.data.data.accountId,
        systemType: "1",
        type: "msg"
      }
      _.$setSessionStorage("userId", objects.userId)
      this.$webSocket.sendMsg(objects, () => {})
      // =================================================
      if (res.data.data.areaMsg) {
        const h = this.$createElement
        this.$msgbox({
          title: "异常登录提醒",
          message: h("p", null, [h("div", { style: "color: red" }, `${res.data.data.areaMsg}`)]),
          showCancelButton: false,
          showClose: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(action => {
          //登录成功
          const defaultDisplay = res.data.data.defaultDisplay
          _.$setSessionStorage("userType_s", res.data.data.account.userType)
          _.$setSessionStorage("user", res.data.data)
          //_.$setSessionStorage('superPreventOperation',res.data.msg);
          _.$setSessionStorage("userMssage_name", res.data.data.account.userName || res.data.data.account.userLoginName)
          _.$setSessionStorage("userMssage_number", res.data.data.account.userLoginName)
          localStorage.setItem("accountId", res.data.data.accountId)
          sessionStorage.setItem("token", res.data.data.token)
          sessionStorage.setItem("cid", res.data.data.historyBook)
          sessionStorage.setItem("bookName_first", res.data.data.bookName)
          _.IS_FIRST_LOGIN(res.data.data.first)

          //查询菜单
          _.loadingLogin = true
          _.$http
            .post("sys/menu/getTree", {})
            .then(msg => {
              _.loadingLogin = false
              if (msg && msg.data.code == "1") {
                _.ADDROUTECHILD(msg.data.data)
                _.$setSessionStorage("menu", msg.data.data)

                // if (defaultDisplay == "1") {
                //   _.$router.push({ path: "/reportDesk/dashboard" })
                // } else {
                  if (msg.data.data.length) {
                    if (!msg.data.data[0].children.length) {
                      _.$router.push({ path: `${msg.data.data[0].href}` })
                    } else {
                      _.$router.push({ path: `${msg.data.data[0].children[0].href}` })
                    }
                  } else {
                    _.$message.warning("系统提示：当前账户无权限！")
                  }
                // }
              }
            })
            .catch(e => {
              _.loadingLogin = false
            })
        })
      } else {
        //登录成功
        const defaultDisplay = res.data.data.defaultDisplay
        _.$setSessionStorage("userType_s", res.data.data.account.userType)
        _.$setSessionStorage("user", res.data.data)
        //_.$setSessionStorage('superPreventOperation',res.data.msg);
        _.$setSessionStorage("userMssage_name", res.data.data.account.userName || res.data.data.account.userLoginName)
        _.$setSessionStorage("userMssage_number", res.data.data.account.userLoginName)
        localStorage.setItem("accountId", res.data.data.accountId)
        sessionStorage.setItem("token", res.data.data.token)
        sessionStorage.setItem("cid", res.data.data.historyBook)
        sessionStorage.setItem("bookName_first", res.data.data.bookName)
        _.IS_FIRST_LOGIN(res.data.data.first)
        //查询菜单
        _.loadingLogin = true
        _.$http
          .post("sys/menu/getTree", {})
          .then(msg => {
            _.loadingLogin = false
            if (msg && msg.data.code == "1") {
              _.ADDROUTECHILD(msg.data.data)
              _.$setSessionStorage("menu", msg.data.data)
              // if (defaultDisplay == "1") {
              //   _.$router.push({ path: "/reportDesk/dashboard" })
              // } else {
                if (msg.data.data.length) {
                  if (!msg.data.data[0].children.length) {
                    _.$router.push({ path: `${msg.data.data[0].href}` })
                  } else {
                    _.$router.push({ path: `${msg.data.data[0].children[0].href}` })
                  }
                } else {
                  _.$message.warning("系统提示：当前账户无权限！")
                }
              // }
            }
          })
          .catch(e => {
            _.loadingLogin = false
          })
      }
    },
    // 点击阅读条款
    handleClickRead(type) {
      if (type === "1") {
        window.open("/static/servicePage/service.html")
      } else {
        window.open("/static/servicePage/privacy.html")
      }
    },
    /**
     * @description 发送验证码
     * @param {string} mobile 手机号
     * @param {number} type 1 注册，2 登陆
     */
    postValide(mobile, type = 2) {
      const _ = this
      let exp = /^1[0-9]{10}$/
      if (mobile == "") {
        _.$message({
          message: "请先填写手机号码!",
          type: "error"
        })
      } else if (!exp.test(mobile)) {
        _.$message.error("请填写正确的手机号码!")
      } else {
        _.msg = "发送中"
        _.disable = true
        _.$http.post("sys/sendMessage/sendSms", { mobile, type }).then(res => {
          if (res && res.data.code == "1") {
            _.msg = "发送成功"
            let i = 60
            var times = setInterval(() => {
              i--
              _.msg = i + " s"
              if (i <= 0) {
                clearInterval(times)
                _.msg = "重新发送"
                _.disable = false
              }
            }, 1000)
          } else {
            _.msg = "重新发送"
            _.disable = false
          }
        })
      }
    },
    // 获取报价
    getVipsPrice(ref) {
      if (!this.vipForm.agree) {
        return this.$message.warning("请您阅读Mankoo相关服务和隐私条款并同意!")
      }

      const _ = this
      _.$refs[ref].validate(valid => {
        if (valid) {
          try {
            this.isButtonDisbale = true
            this.disShow_loading = true
            _.$http.post("account/experience/save", this.vipForm).then(res => {
              this.disShow_loading = false
              this.isButtonDisbale = false
              if (res && res.data.code == 1) {
                this.$alert("我们客服已收到您的申请请求，稍后会有专业客服联系您！", "温馨提示", {
                  confirmButtonText: "确定",
                  showClose: false,
                  callback: action => {
                    this.disShow = !this.disShow
                  }
                })
              }
            })
          } catch (e) {
            this.disShow_loading = false
            this.isButtonDisbale = false
          }
        }
      })
    }, //查询用户是否密码输入超过5次
    checkUserAlign() {
      const _ = this
      let exp = /^1[0-9]{10}$/
      if (_.loginForm1.loginName == "") {
        return false
      }
      if (!exp.test(_.loginForm1.loginName)) {
        return false
      }
      _.$http
        .post("sys/login/isCode", {
          loginName: _.loginForm1.loginName
        })
        .then(res => {
          if (res.data.code == "5") {
            _.loginForm.loginName = _.loginForm1.loginName
            _.method = true
            _.$message.warning(res.data.msg)
          }
        })
        .catch(e => {})
    }
  },

  watch: {
    QR_loginStatus(val, oldVal) {
      if (!val) return
      let res = {
        data: val
      }
      if (res.data && res.data.data) {
        const data = res.data.data
        if (data.cdkey) {
          this.cdkVisible = true
          this.cdkSelectLoginName = data.loginName
          return
        }
        this.loginSuccess(res)
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~@/pages/styles/login.less");
</style>


// WEBPACK FOOTER //
// src/pages/login.vue